module.exports = __webpack_public_path__ + "img/WorldBuildingABCEntrance.d6993f44.png";